module.exports = __webpack_public_path__ + "img/bgimage.8c75d652.jpg";